import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/opt/buildhome/repo/src/components/layouts/MdxLayout.js";
import SEO from "../../components/Seo";
import WineQuery from "../../components/WineQuery";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <SEO title="Wine" description="Minimal-intervention Washington state wines" mdxType="SEO" />
    <article className="mx-auto prose prose-xl">
      <h1 {...{
        "id": "wine"
      }}>{`Wine`}</h1>
      <h2 {...{
        "id": "quality-fruit-meets-minimal-intervention-methods"
      }}>{`Quality fruit meets minimal-intervention methods.`}</h2>
      <p>{`Our wines celebrate the unique qualities of each grape variety and the place it was grown, with a focus on balance and nuance rather than heavy extraction, oak, and alcohol.`}</p>
      <h2 {...{
        "id": "handmade-from-start-to-finish"
      }}>{`Handmade from start to finish`}</h2>
      <p>{`We start with fabulous fruit and work to bring out the best in each batch. Every product is thus unique, and you'll enjoy a wide variety of styles within our portfolio. We produce small batches of quality products, so availability is limited. We invite you to `}<a parentName="p" {...{
          "href": "/club"
        }}>{`join our club`}</a>{` to access our latest creations.`}</p>
      <h2 {...{
        "id": "were-just-getting-started"
      }}>{`We're just getting started.`}</h2>
      <p>{`We're gradually rolling out our inaugural vintage whites and reds.`}</p>
      <p>{`This is only the beginning. Stay tuned for exciting 2021 releases.`}</p>
      <p><span parentName="p" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "800px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "48%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAKABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAAQCA//EABcBAAMBAAAAAAAAAAAAAAAAAAABAgP/2gAMAwEAAhADEAAAAeFCHO6mgv/EABoQAAMAAwEAAAAAAAAAAAAAAAECAwAREhP/2gAIAQEAAQUCLT35SWaNLlsiSW4XP//EABURAQEAAAAAAAAAAAAAAAAAAAEQ/9oACAEDAQE/AUn/xAAWEQADAAAAAAAAAAAAAAAAAAABAhD/2gAIAQIBAT8BUz//xAAdEAACAAcBAAAAAAAAAAAAAAAAAQIDEBESMTKR/9oACAEBAAY/AsdEyJo6VLNnK8P/xAAcEAEAAQQDAAAAAAAAAAAAAAABABEhMVFBcaH/2gAIAQEAAT8hS+AclIeijuUCz3CNbEEoTSzLF//aAAwDAQACAAMAAAAQi9//xAAWEQADAAAAAAAAAAAAAAAAAAAAARH/2gAIAQMBAT8Qm0Q//8QAFxEBAQEBAAAAAAAAAAAAAAAAAQARUf/aAAgBAgEBPxDQW05f/8QAHhABAQACAAcAAAAAAAAAAAAAAREAMSFBUWFxgZH/2gAIAQEAAT8QMSRF2Lq/cUkMjqeDlcWRABF2x6k8mPB61CPrBlLN6M//2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Archibald James wine bottles",
            "title": "Archibald James wine bottles",
            "src": "/static/260ebd7c5b86c91d0bf38a6a18d03b49/4b190/archibald-james-four-wine-bottles.jpg",
            "srcSet": ["/static/260ebd7c5b86c91d0bf38a6a18d03b49/e07e9/archibald-james-four-wine-bottles.jpg 200w", "/static/260ebd7c5b86c91d0bf38a6a18d03b49/066f9/archibald-james-four-wine-bottles.jpg 400w", "/static/260ebd7c5b86c91d0bf38a6a18d03b49/4b190/archibald-james-four-wine-bottles.jpg 800w", "/static/260ebd7c5b86c91d0bf38a6a18d03b49/e5166/archibald-james-four-wine-bottles.jpg 1200w", "/static/260ebd7c5b86c91d0bf38a6a18d03b49/b17f8/archibald-james-four-wine-bottles.jpg 1600w", "/static/260ebd7c5b86c91d0bf38a6a18d03b49/9b2fa/archibald-james-four-wine-bottles.jpg 3558w"],
            "sizes": "(max-width: 800px) 100vw, 800px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
    `}</span></p>
      <h2 {...{
        "id": "wine-list"
      }}>{`Wine List`}</h2>
      <p>{`Most of our wines are meant to cellar, but we release them when they're ready to drink. Check our `}<a parentName="p" {...{
          "href": "https://club.archibaldjames.com/shop"
        }}>{`online shop`}</a>{` for current availability. `}<a parentName="p" {...{
          "href": "/club"
        }}>{`Club members`}</a>{` have priority access.`}</p>
      <h3 {...{
        "id": "lineup"
      }}>{`Lineup`}</h3>
      <WineQuery mdxType="WineQuery" />
      <hr></hr>
      <p><span parentName="p" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "800px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "133.5%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,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')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Archibald James grapes",
            "title": "Archibald James grapes",
            "src": "/static/779e25c2e04676eb060f9c425bda0f9e/5a190/grappe.png",
            "srcSet": ["/static/779e25c2e04676eb060f9c425bda0f9e/772e8/grappe.png 200w", "/static/779e25c2e04676eb060f9c425bda0f9e/e17e5/grappe.png 400w", "/static/779e25c2e04676eb060f9c425bda0f9e/5a190/grappe.png 800w", "/static/779e25c2e04676eb060f9c425bda0f9e/d9199/grappe.png 960w"],
            "sizes": "(max-width: 800px) 100vw, 800px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
    `}</span></p>
      <p><span parentName="p" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "800px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "133.5%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAbCAIAAADzvTiPAAAACXBIWXMAAAsTAAALEwEAmpwYAAAGeklEQVQ4ywFvBpD5AOzr6+jq7NzT1NG4s8ajm7qNgbKCcZdfSpxvZJ9wZJ5qWJdjS51lSYRNNHhDLXtBKHU6I3c4IGguHYBBKgD2+/vx7uzfzcizoJ3Fqpylg26GZFKWcl98W1CFbGGLb2V/WVB6TkJ0QC97PSZ8PiV6PCOQTC2bVzikYD4AyKigunlqd0g1rYRiq4dlgWpRhXVgIRsXim5Q1K+Bw55ym3RXlGlfoG5hlFtEllc6m1k4klEvi0knf0MmALR+Xl4tIJZzS8yicWFNNcWjcjsvIXxnUP/dq+nFl/TUpNate7upl7i0uJ6GfIhlWXlMOG08Imo3GGYvEQDOp3pyVz+4iFhyVzqOcUuOckohHBfpyJ3yz6HkwJT32Kjwz57Pq4GkqKKWn56tqZ+topWUhHeLeW6kk4QA6cKVx590pXpTVD8qsYxbRTUgXE09/tqr5sOY6cSX7Mib9ter3bOCcGhQa3Zr17mRkIJqiYZ3vaqPqKaVAPXTqeC4ipt5VUgzH7aKVyAaD4h0W//aq+bAlubBlu7Im/XSpe/EkpeLcKKqm/bQpKKPcKqihr6Yam5tXAD42rTuyaCafV5HMh63jFwUEg6jiWv71Kbuxpr0zJ/30aPzzaDzxJGemIGvr5ruyJu9rZLPwaHDp36hpZQA9Nez99avrI5wRzUisohaEhEOqI5w+dSn7smf8cmd9c+i8Mib8sSRm5qGsLCY6saZuKyVybmYsJZrf4d3APPTsPTSr7ycfUM0JayDWBgXEpiDZ/jTpu7Jn/PJnPfRpPHLnuy6ho+NeKutmenDkpOOea6gfId0TVJZSQD42Lfv0LHIpIVCNSiceVQvKSBzYE780J/wyJ30yZz2zaD2z6PbrHl0cFuWnIvTsINeYlNLTTtOTTxfY1UA99e67tCz2rmXXkw6dFk/YlA8OzMu9sma8cec9Mic9suf+c+iuZh1SEpCVlxQcmVMUFFFREEzQDsoSEo9APPVue3NssSig41wT008K5Z4VR0ZE7ORb//Upu/CmffJoea3jHBlVjtBQjk2Ljk5MU5LPXVyWnJyWm1zYwDv0rrsyKiXd2JeSTZ0Wz5rVz9gVD4xKyLTsIv2y6PhtpSSdmE6Ni5CPDJPUEtMUUtLXFqKf2GQmpKDhn4A6s2117aYkYuEPkFDjYiCgnltTUk8SUM4VExChXNhcmZdSkpLRjwxSExOYWRheYOEeZGZrZRxaXqFV1ZZANy+p52EbycrLSIkJ1dTV1ROS0NBOVlUTlFRUWFVTWtWSWFZWaCMflxodGdscpmWlJimroZwWR8xRSYnJwDMrZZIRkYSFBUhGhYhHBs7NjJPSkdNTlJ8aFizjW6BcmpiXmOxnJVceJecm6Cuo6CEkp5QRj8IFSUmIx8AmId6LjE2KCgtQTo3R0REPzcyMS4rODpDUklIfWJNZV1db2pyr6qvc5nCq56dnpWXP1FlLisoHBwaKCMcAEI+PT06PU9MUmpeXFhKRScoLyYmMTMyODMtME1DRDxGVm1ncpOcs2aNt7Gfn350fQ4hNjAyNDEsIioiFwBMSE5VUVhpW1p9ZV1SWmxNaIonQmIzNDs4NDg/U2hoeZK6paNyfJNAaZaejZg4PlQcNFI4QlM2NTU0LSYAU1FYS0E8YFlbUV5tT2eCTFRlKS45NTE0NUllgo2i07av78zGsJ6iHkNuRUZaECxSKUZyKjFCKiguMy4uAGtsgXdweHtsZUxQXU9NV0xAP1JXak9igXKIq9Gzrseqqd7AwMuurhAjQAkkSCZFdik8YCQkLykjJi0lJQBkXWmyprJnXWRKSVN8hZmEe4V2hqZyjLWtoqvYs63GrbPZvMG9oaMPGjEWMlosRXQrNFEvKzUvKCktJiQAQjg9Qzg9MjFBgoijgZrHfYyyeImsi5evy6umza6xvqez0La8lH6ABxk2FihJJTRYLjJOMC07LikwKyYrAEI9RkA2OFVQVoeMqI2o33+j33Wa06ChuMunoq2bqZqOo7ufomVaYwYVMQ4VKRYcLy4xSC4sPiUiMSckMwA8O0pHNSw/LydjVlp7hqtymdpjltyrmqS1nKKEf5t0bISMcnUvLToMFCUWFycaGScnJjosK0QlIjUhHi8APjpLRjUvMyYfSTo6YVZiW2yYU3u3o42TkYSXaWN7Y1ZiUT5BHBknGxomGRcmHxstKClCISE2GhgpHx0xvNTkX6+uLfwAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "barrels",
            "title": "barrels",
            "src": "/static/7c05d031045203671e0682e046ceadf9/5a190/barrels.png",
            "srcSet": ["/static/7c05d031045203671e0682e046ceadf9/772e8/barrels.png 200w", "/static/7c05d031045203671e0682e046ceadf9/e17e5/barrels.png 400w", "/static/7c05d031045203671e0682e046ceadf9/5a190/barrels.png 800w", "/static/7c05d031045203671e0682e046ceadf9/d9199/barrels.png 960w"],
            "sizes": "(max-width: 800px) 100vw, 800px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
    `}</span></p>
    </article>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      